// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"1ba678fe1dc2aa01cd3b","883":"73d38cf181e173f2cd12"}[chunkId] + ".js";
};